import { c as _c } from "react/compiler-runtime";
import Link from "next/link";

/** The square app icon: a page turning into pixels. Same drawing as app/icon.svg. */
export function LogoMark(t0) {
  const $ = _c(8);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 32 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect width="32" height="32" rx="8" fill="#4f3bef" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M7 6.5h9l5 5V25H7z" fill="#fff" stroke="#fff" />;
    t4 = <path d="M16 6.5v5h5z" fill="#c9c1ff" stroke="#c9c1ff" />;
    t5 = <rect x="9.5" y="14" width="6.5" height="1.8" rx=".9" fill="#c9c1ff" />;
    t6 = <rect x="9.5" y="17.6" width="4" height="1.8" rx=".9" fill="#c9c1ff" />;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <g transform="translate(-1 -0.6)" strokeLinejoin="round">{t3}{t4}{t5}{t6}<g stroke="#4f3bef" strokeWidth="1.6" paintOrder="stroke"><rect x="16.2" y="16.2" width="5" height="5" rx="1" fill="#ff5c7a" /><rect x="21.6" y="16.2" width="5" height="5" rx="1" fill="#ffc53d" /><rect x="16.2" y="21.6" width="5" height="5" rx="1" fill="#2ed3b7" /><rect x="21.6" y="21.6" width="5" height="5" rx="1" fill="#fff" /></g></g>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== size) {
    t8 = <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">{t2}{t7}</svg>;
    $[6] = size;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
}
export function Logo(t0) {
  const $ = _c(8);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const t2 = size === "md" ? 34 : 30;
  let t3;
  if ($[0] !== t2) {
    t3 = <LogoMark size={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `font-heading font-extrabold tracking-[-0.03em] ${size === "md" ? "text-2xl" : "text-xl"}`;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-brand">{"&"}</span>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t4) {
    t6 = <span className={t4}>PDF {t5} Pixel</span>;
    $[3] = t4;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t3 || $[6] !== t6) {
    t7 = <Link href="/" aria-label="PDF & Pixel home" className="inline-flex min-h-11 items-center gap-2.5 rounded-lg text-ink">{t3}{t6}</Link>;
    $[5] = t3;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}